module.exports = __webpack_public_path__ + "img/petrol-ofisi-logo.17b5c2b8.svg";